webpackJsonp([4],{

/***/ 3:
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(3);

var _angular2 = _interopRequireDefault(_angular);

var _login = __webpack_require__(489);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_angular2.default.module('upglide.module.login', []).controller('LoginController', _login.LoginController);

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LoginController.$inject = ["$scope", "$location", "$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginController = LoginController;

__webpack_require__(490);

function LoginController($scope, $location, $timeout) {
    'ngInject';

    $scope.logo = "VMS_Logo.png";
    // Current Year
    $scope.currentYear = new Date().getFullYear();

    // Data form
    $timeout(function () {
        $scope.user = { username: $('#UserName').val(), password: $('#Password').val(), id: $('#BusinessID').val() };
    }, 5000);
    $scope.master = {};

    $scope.update = function (user) {
        $scope.master = angular.copy(user);
        console.log($scope.master);
    };

    // Single sign in
    $scope.singleSignIn = $location.url();

    if ($scope.singleSignIn == "/#singlelogin") {
        $scope.singleSignInBtn = true;
    } else {
        $scope.singleSignInBtn = false;
    }
    // DONE
    //Shivakumar | UP2018-2393 | 22-July-2020 | Get cookies details for Remember Password
    $scope.getCookies = function () {
        $scope.user = { username: get_cookie('UserName'), password: get_cookie('Password'), id: get_cookie('BusinessID') };
    };
    $scope.getCookies();
    function get_cookie(name) {
        var output;
        var encrypted_cookie = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (encrypted_cookie != null & encrypted_cookie != "") {
            $.ajax({
                type: "POST",
                url: 'login.aspx/Decrypt_Cookie',
                async: false,
                contentType: 'application/json;charset=utf-8',
                data: JSON.stringify({
                    'cookie_name': encrypted_cookie[1]
                }),
                dataType: 'JSON',
                success: function success(result) {
                    output = result.d;
                }
            });
            return output;
        }
    }
}

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(491);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./login.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./login.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "#loginpage .navbar-default{width:80%;height:75px;margin-left:auto;margin-right:auto;border-top-right-radius:0;border-top-left-radius:0}#loginpage .navbar-default img{width:200px;margin-top:-27px}#loginpage #loginform{margin-left:auto;margin-right:auto;padding:25px;background-color:#fff;border:thin solid #eaeaea;max-width:500px}#loginpage #loginform .form-control{max-width:450px}#loginpage #loginform .btn-primary{margin-top:15px}#loginpage #loginform span{font-size:.8em;color:crimson}#loginpage li{display:inline;padding-right:5px}#loginpage ul{margin-top:75px;list-style-type:none;padding:0}#loginpage .text-center p{font-size:.8em;color:#a9a9a9}#loginpage footer{position:fixed;bottom:0;background-color:#f7f7f7;border:thin solid #eaeaea;z-index:-1;left:0;right:0;height:60%}#loginpage .inner-addon{position:relative}#loginpage .inner-addon .glyphicon{position:absolute;padding:9px;pointer-events:none}#loginpage .left-addon .glyphicon{left:0}#loginpage .left-addon input{padding-left:30px}#loginpage h1{font-weight:200;font-size:2em}#loginpage #vmsLogin .form-control{margin-top:15px!important}@media only screen and (max-width:992px){#loginpage .navbar-default{border-radius:0;width:100%}}", ""]);

// exports


/***/ })

},[488]);


// WEBPACK FOOTER //
// login.bundle.js